import type { PortfolioSkillCategoryResource } from "api/generated";
import type { PortfolioSkillCategory } from "portfolio/types";

export const skillCategoryFromDto = (
  dto: PortfolioSkillCategoryResource,
): PortfolioSkillCategory => ({
  id: dto.id,
  schoolId: dto.school_id ?? null,
  name: dto.name,
  colorCode: dto.color_code ?? null,
});
